<template>
  <div
    class="DetailSummary">
    <div
      class="_leading">
      <!-- DESKTOP LOGO -->
      <AppIcon
        :size="100"
        :src="app.logo"
      />
    </div>

    <div
      class="_trailing">
      <div
        class="_header">
        <div
          class="_header-leading">
          <!-- MOBILE LOGO -->
          <AppIcon
            :size="60"
            :src="app.logo"
          />
        </div>

        <div
          class="_header-trailing">
          <!-- PUBLISHER -->
          <div>
            <router-link
              v-if="app.publisher"
              class="_publisher link"
              key="DS-publisher"
              :to="{
                name: 'search',
                query: {
                  publisher: app.publisher,
                },
              }">
              {{ app.publisher }}
            </router-link>
            <BasePlaceholder
              v-else
              width="30%"
              height="12px"
              class="mb-1"
            />
          </div>

          <!-- TITLE -->
          <h1
            class="_title capitalize">
            {{ app.title }}
            <BasePlaceholder
              v-if="!app.title"
              key="DS-title-placeholder"
              width="90%"
              height="30px"
            />
          </h1>
        </div>
      </div>

      <!-- SUBTITLE -->
      <div
        v-if="loading || app.subTitle"
        class="_summary font-18 mt-half">
        <div
          class="_clamp"
          v-html="app.subTitle">
        </div>
        <div
          v-if="loading"
          key="DS-subtitle-placeholder">
          <BasePlaceholder
            height="12px"
          />
          <BasePlaceholder
            class="mt-1"
            width="60%"
            height="12px"
          />
        </div>
      </div>

      <!-- WHO FOR && SETUPEFFORT -->
      <div
        v-if="loading"
        class="mt-4 pt-2 border-top">
        <BasePlaceholder
          width="33%"
          height="48px"
        />
        <div
          class="mt-2 pt-2 border-top">
          <BasePlaceholder
            :blocks="2"
            width="50%"
            height="48px"
          />
        </div>
      </div>

      <div
        v-if="app.whoFor || app.setupEffort"
        class="_highlights mt-3"
        key="DS-highlights-whofor-and-effort">
        <div
          v-if="app.whoFor"
          class="_highlight"
          key="DS-highlights-whofor">
          <h4
            class="_title">
            Who is this app for
          </h4>
          <p>
            {{ app.whoFor }}
          </p>
        </div>

        <div
          v-if="app.setupEffort"
          class="_highlight"
          key="DS-highlights-effort">
          <h4
            class="_title">
            Setup effort
          </h4>
          <p>
            {{ app.setupEffort.label }}
          </p>
        </div>
      </div>

      <!-- BENEFITS -->
      <div
        class="_highlights"
        v-if="app.benefits"
        key="DS-highlights-benefits">
        <div
          class="_highlight">
          <h4
            class="_title">
            Benefits
          </h4>
          <ul
            class="_highlight-list">
            <li
              class="_highlight-list_item"
              v-for="benefit in app.benefits"
              :key="benefit">
              {{ benefit }}
            </li>
          </ul>
        </div>
      </div>

      <!-- CTA -->
      <DetailCta
        v-if="!loading"
        class="DetailSummary_cta"
        :app="app"
        :user-is-customer="$root.userIsCustomer"
      />
    </div>
  </div>
</template>

<script>
import AppIcon from '@/components/AppIcon.vue';
import BasePlaceholder from '@/components/BasePlaceholder.vue';
import DetailCta from '@/components/DetailCta.vue';

export default {
  name: 'DetailSummary',

  components: {
    AppIcon,
    BasePlaceholder,
    DetailCta,
  },

  props: {
    app:     { type: Object,  default: () => ({}) },
    loading: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.DetailSummary {
  display: flex;
  padding: 24px;
  border: $border;
  background-color: $white;
  ._leading {
    flex: 0 1 100px;
    min-width: 100px;
  }
  ._trailing {
    flex: 1 1 auto;
    padding-left: 24px;
  }
}

.DetailSummary ._header-leading {
  display: none;
}

.DetailSummary ._publisher {
  color: $dark-blue;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.DetailSummary ._summary ._clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.DetailSummary ._highlights {
  display: flex;
  padding: 16px 0;
  border-top: $border;
}

.DetailSummary ._highlight {
  flex: 1 1 50%;
  padding: 2px 8px 2px 0;
  font-size: 12px;
  list-style: inside;
}

._highlight + ._highlight {
  padding-left: 24px;
  border-left: $border;
}

._highlight ._title {
  padding-bottom: 4px;
}

._highlight-list {
  display: flex;
  flex-wrap: wrap;
}

._highlight-list_item {
  flex: 1 1 50%;
  max-width: 50%;
  padding-right: 16px;
}

.DetailSummary_cta {
  display: none !important;
}

@media only screen and (max-width: 600px) {
  .DetailSummary ._leading {
    display: none;
  }

  .DetailSummary ._trailing {
    padding-left: 0;
  }

  .DetailSummary ._header {
    display: flex;
  }

  .DetailSummary ._header-leading {
    display: block;
    flex: 0 1 60px;
    min-width: 60px;
  }

  .DetailSummary ._header-trailing {
    flex: 1 1 auto;
    padding-left: 16px;
  }

  .DetailSummary ._header ._title {
    font-size: 20px;
  }

  .DetailSummary ._summary {
    font-size: 14px;
  }
}

@media only screen and (max-width: 800px) {
  .DetailSummary_cta {
    display: block !important;
  }
}
</style>
